export const home ="/"
export const login ="/login"
export const signup ="/signup"
export const forgotpassword ="/forgot-password"
export const resetpassword ="/reset-password"
export const editprofile= "/edit-profile"
export const changepassword= "/change-password"

export const ordermanagement= "/order-management"
export const productcatalog = "/product-catalog"
export const designerManagement="/designer-management"
export const customermanagement = "/customer-management"
export const promotionsmanagement = "/promotions-management"
export const shippingmanagement= '/shipping-management'
export const paymentsmanagement = "/payments-management"
export const viewproductdetails = "/view-product-details"
export const viewvariantdetails = "/view-variant-details"
export const contactus="/contact-us"
export const privacypolicy ='/privacy-policy'
export const termsandconditions ='/terms-and-conditions'
export const shippinginformation ='/shipping-information'
export const returnandexchange = "/return-and-exchange"
export const legalandpolicy = '/legal-and-policy'
export const buyermanagement = '/buyer-management'
export const viewbuyerdetails = '/view-buyer-detail'
export const viewquerydetails = '/view-query-details'


export const vendorlisting="/vendorlisting"
export const categoricallisting ="/categoricallisting" 
export const categorymanagement = "/categorymanagement"
export const subcategorymanagement = "/subcategorymanagement"
export const vendorpromotion = "/vendorpromotion"
export const consumerpromocodemanagement = "/consumerpromocodemanagement"
export const commissionmanagement ="/commissionmanagement"
export const querymanagement = "/querymanagement"
export const sizemanagement = "/sizemanagement"
export const colormanagement = "/colormanagement"
export const typemanagement = "/typemanagement"
export const materialmanagement = "/materialmanagement"
export const faqmanagement = "/faq-management"
export const configurationmanagement ="/configuration-management"
export const bannermanagement="/banner-management"

//add-edit Pages
export const coloraddedit = "/color-add-edit"
export const materialaddedit = "/material-add-edit"
export const typeaddedit = "/type-add-edit"
export const sizeaddedit = "/size-add-edit"
export const subcategoryaddedit = "/sub-category-add-edit"
export const categoryaddedit = "/category-add-edit"
//view Pages
 export const designerview = "/designer-view"

 //page not found
 export const notfound="*"



